import { z } from 'zod';

export const TipoTrabalhoSchema = z.enum([
  'NORMALIZAR',
  'SEGMENTAR',
  'TRANSCREVER',
  'RESUMO',
  'ATA',
  'PERGUNTA',
  'CTRL_K',
  'RETENCAO',
]);
export type TipoTrabalho = z.infer<typeof TipoTrabalhoSchema>;

export const EstadoTrabalhoSchema = z.enum([
  'PENDENTE',
  'EXECUTANDO',
  'CONCLUIDO',
  'ERRO',
  'CANCELADO',
]);
export type EstadoTrabalho = z.infer<typeof EstadoTrabalhoSchema>;

/**
 * Teto de tempo por tipo. Um trabalho EXECUTANDO além do teto volta para
 * PENDENTE (o daemon pode ter morrido no meio) até três tentativas.
 */
export const TIMEOUT_TRABALHO_MIN: Record<TipoTrabalho, number> = {
  NORMALIZAR: 30,
  SEGMENTAR: 10,
  TRANSCREVER: 5,
  RESUMO: 10,
  ATA: 10,
  PERGUNTA: 10,
  CTRL_K: 3,
  RETENCAO: 60,
};

export const MAXIMO_TENTATIVAS = 3;

export const ListarTrabalhosSchema = z.object({
  estado: EstadoTrabalhoSchema.optional(),
  tipo: TipoTrabalhoSchema.optional(),
});
export type ListarTrabalhos = z.infer<typeof ListarTrabalhosSchema>;

export const TrabalhoSchema = z.object({
  id: z.string(),
  tipo: TipoTrabalhoSchema,
  estado: EstadoTrabalhoSchema,
  gravacaoId: z.string().nullable(),
  sessaoId: z.string().nullable(),
  maquinaId: z.string().nullable(),
  tentativas: z.number().int().nonnegative(),
  erro: z.string().nullable(),
  criadoEm: z.iso.datetime(),
  concluidoEm: z.iso.datetime().nullable(),
});
export type Trabalho = z.infer<typeof TrabalhoSchema>;
